function getFieldsToIgnore(jsonSchema, prevArr = []) {
  const { type, properties, items } = jsonSchema;
  switch (type) {
    case 'object': {
      Object
        .keys(properties)
        .filter(key => properties[key].displayOnly)
        .forEach(key =>
          (properties[key].displayOnly ?
            prevArr.push(key) : getFieldsToIgnore(properties[key], prevArr)));
      break;
    }
    case 'array': {
      getFieldsToIgnore(items, prevArr);
      break;
    }
    default:
      break;
  }

  return prevArr;
}

export default getFieldsToIgnore;



// WEBPACK FOOTER //
// ./src/byob-cms/src/GqlCmsConfigLib/getFieldsToIgnore.js